import getAdditionalServices from '../../api/deals/getAdditionalServices';
import Select from '../Select/Select';
import usePaginatedSelect from '../../hooks/usePaginatedSelect';

const fetchFn = (page) => getAdditionalServices({ page });
const extractItems = (res) => res.data.additionalServices;
const formatOption = (item) => ({ value: item.id, label: item.title });

const SelectAdditionalServices = ({ handleSetSelect, handleSetState, style, ...props }) => {
  const { data, isLoading, loadMore } = usePaginatedSelect({ fetchFn, extractItems, formatOption });

  return (
    <Select
      handleSetSelect={(val) => handleSetSelect && handleSetSelect(val)}
      handleSetState={handleSetState}
      options={data}
      title={'Услуги'}
      placeholder={'Выберите из списка'}
      onFocus={loadMore}
      style={style}
      isLoading={isLoading}
      isMulti
      isSearchable
      {...props}
    />
  );
};

export default SelectAdditionalServices;
